import getScrollDistance from 'bundles/cds-labs/components/OverflowCarousel/getScrollDistance';

const navigateToItem = ({
  index,
  carouselRefCurrent,
  itemsOffset,
  isRightToLeft = false,
  offset = 4,
}: {
  index: number;
  carouselRefCurrent: HTMLDivElement;
  itemsOffset: Map<string, { offsetLeft: number; offsetWidth: number }>;
  isRightToLeft?: boolean;
  offset?: number;
}) => {
  const itemOffset = itemsOffset?.get(index.toString());

  if (!itemOffset) {
    return;
  }

  const scrollDistance = getScrollDistance({
    value: itemOffset,
    isRightToLeft,
    carouselRefCurrent,
    offset,
  });

  carouselRefCurrent.scrollTo({
    left: isRightToLeft ? -scrollDistance : scrollDistance,
    behavior: 'smooth',
  });
};

export default navigateToItem;
